import { render, staticRenderFns } from "./indexQnz.vue?vue&type=template&id=378fc0bb&scoped=true"
import script from "./indexQnz.vue?vue&type=script&lang=js"
export * from "./indexQnz.vue?vue&type=script&lang=js"
import style0 from "./indexQnz.vue?vue&type=style&index=0&id=378fc0bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378fc0bb",
  null
  
)

export default component.exports